import React from "react"
import { Card, CardBody, Col, Input, Label, Row } from "reactstrap"
import Switch from "react-switch"
import { VenueGoogleMap } from "../VenueStep"

function VenueParking({
  validation,
  toggleSection = () => { },
  openSection,
  addParkingType,
  removeParkingType,
}) {
  const handleParkingLocationSelect = async (lat, lng, index) => {
    validation.setFieldValue(`parking[${index}].parking_address`, "")

    validation.setFieldValue(`parking[${index}].latitude`, lat)
    validation.setFieldValue(`parking[${index}].longitude`, lng)

    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
      )
      const data = await response.json()

      if (data?.display_name) {
        validation.setFieldValue(
          `parking[${index}].parking_address`,
          data.display_name
        )
      }
    } catch (error) {
      console.error("Reverse geocoding failed:", error)
    }
  }
  const handleAddParkingType = () => {
    const existing = validation.values.parking || []

    const incomplete = existing.some(
      p =>
        !p.vehicleType?.trim() ||
        !p.capacity?.toString().trim() ||
        !p.parking_name?.trim() ||
        !p.parking_address?.trim()
    )

    if (incomplete) {
      alert("Please fill all Parking Entries before adding a new one.")
      return
    }

    addParkingType()
  }

  return (
    <>
      <div className="card border-0 shadow-sm p-3 ">
        <div className="d-flex justify-content-between align-items-center">
          <span className="fw-semibold">Enable Parking</span>
          <Switch
            checked={!!validation.values.enable_parking}
            onChange={checked => {
              validation.setFieldValue("enable_parking", checked)
              if (checked && validation.values.parking.length === 0) {
                validation.setFieldValue("parking", [
                  {
                    vehicleType: "car",
                    capacity: "",
                    parking_name: "",
                    parking_address: "",
                    latitude: "",
                    longitude: "",
                    googleMap: false,
                  },
                ])
              }

              if (!checked) {
                validation.setFieldValue("parking", [])
              }
            }}
            onColor="#34c38f"
            offColor="#b3a692"
            uncheckedIcon={false}
            checkedIcon={false}
            height={16}
            width={32}
            handleDiameter={14}
          />
        </div>
      </div>

      <Col sm="12" className="px-3">
        <div className="mt-3">
          {validation.values.enable_parking && (
            <div className="animate__animated animate__fadeIn">
              {validation.values.parking.map((item, index) => (
                <Row
                  key={index}
                  className="p-4 mb-3 rounded border border-warning bg-warning bg-opacity-10"
                >
                  <Col md={11}>
                    <Row >
                      <Col md={4}>
                        <Label >
                          Vehicle Type
                        </Label>
                        <Input
                          type="select"
                          value={item.vehicleType || "car"}
                          onChange={e =>
                            validation.setFieldValue(
                              `parking[${index}].vehicleType`,
                              e.target.value
                            )
                          }
                        >
                          <option value="car">Car</option>
                          <option value="bike">Bike</option>
                          <option value="both">Both</option>
                        </Input>
                      </Col>

                      <Col md={3}>
                        <Label >
                          Capacity
                        </Label>
                        <Input
                          type="number"
                          min="1"
                          value={item.capacity || ""}
                          onBlur={validation.handleBlur}
                          onChange={e =>
                            validation.setFieldValue(
                              `parking[${index}].capacity`,
                              e.target.value
                            )
                          }
                        />
                        {validation.errors.parking?.[index]?.capacity && (
                          <div className="text-danger">
                            {validation.errors.parking[index].capacity}
                          </div>
                        )}
                      </Col>
                      <Col md={3}>
                        <Label>Parking Name</Label>
                        <Input
                          type="text"
                          value={item.parking_name || ""}
                          onBlur={validation.handleBlur}
                          onChange={e =>
                            validation.setFieldValue(
                              `parking[${index}].parking_name`,
                              e.target.value
                            )
                          }
                        />
                        {validation.errors.parking?.[index]
                          ?.parking_name && (
                            <div className="text-danger">
                              {
                                validation.errors.parking[index]
                                  .parking_name
                              }
                            </div>
                          )}
                      </Col>
                    </Row>

                    <Row className="mt-2 align-items-center">
                      <Col md={8}>
                        <Label>Parking Address</Label>
                        <Input
                          type="text"
                          value={item.parking_address || ""}
                          onBlur={validation.handleBlur}
                          onChange={e =>
                            validation.setFieldValue(
                              `parking[${index}].parking_address`,
                              e.target.value
                            )
                          }
                        />
                        {validation.errors.parking?.[index]
                          ?.parking_address && (
                            <div className="text-danger">
                              {
                                validation.errors.parking[index]
                                  .parking_address
                              }
                            </div>
                          )}
                      </Col>
                    </Row>

                    <Row className="mt-2 align-items-center">

                      <Col
                        md={3}
                        className="d-flex align-items-center pb-2"
                      >
                        <div className="">
                          <div className="d-flex justify-content-between align-items-center">
                            <Switch
                              checked={item.googleMap || false}
                              onChange={checked =>
                                validation.setFieldValue(
                                  `parking[${index}].googleMap`,
                                  checked
                                )
                              }
                              onColor="#34c38f"
                              offColor="#b3a692"
                              uncheckedIcon={false}
                              checkedIcon={false}
                              height={16}
                              width={32}
                              handleDiameter={14}
                            />
                            <Label
                              className="ms-2 mb-0"
                              htmlFor={`map-${index}`}
                            >
                              Google Map
                            </Label>
                          </div>
                        </div>
                      </Col>

                      {item.googleMap && (
                        <Col md={12}>
                          <div
                            style={{
                              height: "150px",
                              marginTop: "15px",
                              position: "relative",
                            }}
                          >
                            <VenueGoogleMap
                              onLocationSelect={(lat, lng) =>
                                handleParkingLocationSelect(
                                  lat,
                                  lng,
                                  index
                                )
                              }
                            />
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Col>
                  <Col md={1} className="d-flex justify-content-center align-items-center bg-danger bg-opacity-10">
                    <button
                      type="button"
                      className="btn btn-link text-danger p-0"
                      onClick={() => removeParkingType(index)}
                    >
                      <i className="mdi mdi-delete-outline fs-4"></i>
                    </button>
                  </Col>
                </Row>
              ))}


            </div>
          )}
        </div>
        <button
          type="button"
          className="btn btn-outline-dark btn-sm mt-2"
          onClick={handleAddParkingType}
        >
          <i className="mdi mdi-plus-circle-outline me-1"></i> Add another parking
        </button>
      </Col>
    </>
  )
}

export default VenueParking
